export const fragenAutoauktionen = [
  {
    question: "Kann ich als Privatperson bei BCA oder Autorola verkaufen?",
    answer: (
      <>
        <p>
          Nein, diese Auktionshäuser sind gewerblichen Händlern vorbehalten. Es
          gibt allerdings Plattformen wie Carsale24, die Privatverkäufe
          ermöglichen.
        </p>
      </>
    ),
  },
  {
    question: "Wie hoch sind die Auktionsgebühren?",
    answer: (
      <>
        <p>
          Die Gebühren variieren. Als Verkäufer zahlst du meist eine Provision von
          2–5 % des Verkaufspreises. Käufer zahlen ebenfalls eine Gebühr, häufig
          gestaffelt nach Preis.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich einen Händler einschalten?",
    answer: (
      <>
        <p>
          Wenn du als Privatperson an einer Händlerauktion teilnehmen willst,
          benötigst du einen Partner. Alternativ gibt es auf einige Portale für
          Privatkunden.
        </p>
      </>
    ),
  },
  {
    question: "Gibt es Garantie oder Rückgaberecht?",
    answer: (
      <>
        <p>
          Nein. Fahrzeuge werden „wie gesehen“ verkauft. Der Käufer trägt das
          Risiko, außer bei arglistiger Täuschung.
        </p>
      </>
    ),
  },
];

